import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { getEnvironmentVariable, isBrand } from "../global/environmentVariables";
import { globalVariables } from "../global/GlobalVariables";
import AffiliateLanding from "../pages/affiliates/AffiliateLanding";
import StripeSessionConfirmation from "../pages/stripe/StripeSessionConfirmation";
import Subscription from "../pages/subscription/Subscription";
import SubscriptionCheckout from "../pages/subscription/SubscriptionCheckout";
import SubscriptionComplete from "../pages/subscription/SubscriptionComplete";
import SubscriptionTrial from "../pages/subscription/SubscriptionTrial";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import ComingSoonPage from "../pages/utility/ComingSoonPage";
import NotFound from "../pages/utility/NotFound";
const SUPPORTS_BCP_PLATFORM_FEATURES =
  getEnvironmentVariable("SUPPORTS_BCP_PLATFORM_FEATURES") === "true";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_PRIMAL = isBrand("primal");

export const subscriptionRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const globalVars = globalVariables();

  return [
    {
      path: "subscription",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "organization/new",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionCheckout subscriptionType="StoreSubscription" />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "new",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionCheckout subscriptionType="Subscription" />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "session-status",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <StripeSessionConfirmation />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: ":subscriptionId",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionComplete />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "circuit-suite",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : globalVars.pricing.subscriptions.circuitSuite ? (
            <Subscription hidePlayerSubs />
          ) : (
            <NotFound />
          )
        },
        {
          path: "player",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : globalVars.pricing.subscriptions.playerSub ? (
            <Subscription hideCircuitSuite />
          ) : (
            <NotFound />
          )
        },
        {
          path: "/subscription/",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            <Subscription />
          ) : (
            <NotFound />
          )
        }
      ]
    }
  ];
};

export const rootSubscriptionRoutes = () => {
  return [
    {
      path: "tacomatrial",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <SubscriptionTrial path="tacomatrial" /> : <NotFound />
    },
    {
      path: "wcw25",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <AffiliateLanding affiliate="wcw25" /> : <NotFound />
    },
    {
      path: "wtc25",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <AffiliateLanding affiliate="wtc25" /> : <NotFound />
    },
    {
      path: "tabletoptitans",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? (
        <AffiliateLanding affiliate="tabletoptitans" />
      ) : (
        <NotFound />
      )
    },
    {
      path: "titans",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <AffiliateLanding affiliate="titans" /> : <NotFound />
    },
    {
      path: "artofwar-subscription",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? (
        <Subscription
          affiliate="artofwar"
          affiliateLabel="The Art of War affiliate"
        />
      ) : (
        <NotFound />
      )
    },
    {
      path: "flgaus-subscription",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <Subscription affiliate="flgAUS" /> : <NotFound />
    },
    {
      path: "nova-subscription",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <Subscription affiliate="nova" /> : <NotFound />
    },
    {
      path: "flg-subscription",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <Subscription affiliate="flg" /> : <NotFound />
    },
    {
      path: "tak-games",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? <Subscription affiliate="takgames" /> : <NotFound />
    },
    {
      path: "tacomasale",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? (
        <AffiliateLanding
          affiliate="TACOMA25"
          frequencies={{
            Yearly: {
              couponCode: "TACOMA25",
              discount: { percentage: 0.2 }
            }
          }}
          couponCode={{
            code: "TACOMA25",
            discount: { percentage: 0.2, onceOff: true },
            frequencies: { Yearly: true }
          }}
        />
      ) : (
        <NotFound />
      )
    },
    {
      path: "spikeybits",
      element: SUPPORTS_BCP_PLATFORM_FEATURES ? (
        <Subscription
          affiliate="spikeybits"
          frequencies={{
            Yearly: {
              couponCode: "SAVER20",
              discount: { percentage: 0.2 }
            }
          }}
          couponCode={{
            code: "SAVER20",
            discount: { percentage: 0.2, onceOff: true },
            frequencies: { Yearly: true }
          }}
        />
      ) : (
        <NotFound />
      )
    }
  ];
};
